import React, {Component} from 'react';
import {Container} from 'semantic-ui-react';

export class Content extends Component {
    render() {
        return (
            <Container>
                {this.props.children}
            </Container>
        );
    }
}
